<div *ngIf="isLoading" class="row">
    <div class="col-12 col-sm-8">
        <div class="skeleton-loader skeleton-loader-table" aria-busy="true"></div>
    </div>
    <div class="col-12 col-sm-4">
        <div class="skeleton-loader skeleton-loader-chart-donut" aria-busy="true"></div>
    </div>
</div>
<div class="row col-12">
    <div class="table-pie-table col-10 col-sm order-sm-first">
        <ag-grid-angular
            class="ag-theme-material"
            [domLayout]="domLayout"
            [style]="gridStyle"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            [columnTypes]="columnTypes"
            [suppressCellSelection]="true"
            groupIncludeFooter="true"
            groupDefaultExpanded="-1"
            groupSuppressRow="true"
            suppressAggFuncInHeader="true"
            headerHeight="0px"
            [rowHeight]="34"
            style="width: 100%"
            (gridReady)="onGridReady($event)"
            (modelUpdated)="onModelUpdated()"
            (cellMouseOver)="onCellMouseOver($event)"
            (cellMouseOut)="onCellMouseOut($event)"
            (rowClicked)="onRowClicked($event)"
            suppressHorizontalScroll="true"
            [gridOptions]="gridOptions"
        ></ag-grid-angular>
    </div>
    <div class="col-2 col-sm-auto order-sm-last">
        <app-bb-chart
            [options]="allocationOptions"
            [data]="allocationData$ | async"
            (chartRef)="chart = $event"
            (drillUp)="drillUp($event)"
        >
            <div
                class="skeleton-loader skeleton-loader-chart-donut mt-4"
                aria-busy="true"
            >
                <span class="visually-hidden">Loading fund allocation...</span>
            </div>
        </app-bb-chart>
    </div>
</div>
